import { redirect } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { getSessionUserFromCookie } from "@/lib/session-utils";
import { Route } from "@/routes/_app";

export type SessionUser = {
	sub: string;
	email?: string;
	name?: string;
};

export const getSessionUser = createServerFn({ method: "GET" }).handler(
	async () => {
		return getSessionUserFromCookie();
	},
);

export async function requireUser() {
	const user = await getSessionUser();

	if (!user) {
		throw redirect({ to: "/auth/login" });
	}

	return user;
}

export function useUser(): SessionUser {
	const { user } = Route.useRouteContext();

	if (!user) {
		throw new Error("No user in session");
	}

	return user;
}
